import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import { ArrowLeftIcon, InformationCircleIcon } from "@heroicons/react/solid";
import LikertView from "../../components/likert";
import usePut from "../../hooks/usePut";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Button } from "../../components/ui";
import ToolTip from "../../components/ui/ToolTip";

const AdvanceShiftEditing = ({ open, onClose, shiftData, mode }) => {
  const navigate = useNavigate();
  // console.log(shiftData);
  const weekendObject = {
    sunday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    monday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    tuesday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    wednesday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    thursday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    friday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
    saturday: [
      {
        type: 1,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 2,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 3,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 4,
        weekendDay: "full_day",
        isSelected: false,
      },
      {
        type: 5,
        weekendDay: "full_day",
        isSelected: false,
      },
    ],
  };
  let formData = {
    shiftName: "",
    shiftInTime: "",
    shiftOutTime: "",
    workingTypeMode: "", // strict | lenient
    minimum_working_hours: "",
    maximum_working_hours: "",
    working_hours: "",
    weekendDefinition: weekendObject,
    first_half_in_time: "",
    first_half_out_time: "",
    second_half_in_time: "",
    second_half_out_time: "",
    shiftGraceInTime: "",
    shiftGraceOutTime: "",
    halfDayInTime: "",
    halfDayOutTime: "",
    half_day_grace: {
      isEnabled: 0,
      half_day_grace_out_time: "",
    },
    reminder_needed: 0,
    reminder_time: "",
    punch_in_reminder_needed: 0,
    punch_in_reminder_time: "",
    cut_off_needed: 0,
    cut_off_time: "",
    cut_off_method: "",
    rw_punch_time_diff_applicable: 0,
    rw_punch_time_diff: "",
    late_redemption_enabled: 0,
    late_redemption_period: "",
    late_penalty: 0,
    late_threshold: "",
    late_penalty_days: "",
    late_grace_available: 0,
    late_grace_time: "",
    calculate_post_shift_out: 0,
    minimum_hours_applicable: 0,
    half_day_late_enable: 0,
  };

  const [shiftFormData, setShiftFormData] = useState(formData);
  const [validationErrors, setValidationErrors] = useState({});
  useEffect(() => {
    if (shiftData) {
      const { weekendDefinition } = shiftData || {};
      let newWeekendDefinition = JSON.parse(JSON.stringify(weekendObject));
      Object.keys(newWeekendDefinition).forEach((weekEndKey) => {
        if (weekEndKey in weekendDefinition) {
          console.log(weekendDefinition);
          weekendDefinition[weekEndKey].forEach((weekEndData, idx) => {
            if (
              newWeekendDefinition[weekEndKey][idx].type ===
              +weekEndData.type ||
              +weekEndData.type === NaN
            ) {
              newWeekendDefinition[weekEndKey][idx] = weekEndData;
            }
          });
        }
      });
      let sanitizedData = { ...shiftData };
      Object.keys(sanitizedData).forEach((key) => {
        if (sanitizedData[key] === "null" || sanitizedData[key] === null) {
          sanitizedData[key] = "";
        }
      });

      // Normalize half_day_grace.isEnabled to 1/0
      if (sanitizedData.half_day_grace) {
        sanitizedData.half_day_grace.isEnabled = sanitizedData.half_day_grace.isEnabled ? 1 : 0;
      }

      let data = {
        ...sanitizedData,
        weekendDefinition: newWeekendDefinition,
      };
      setShiftFormData(data);
    }
  }, [shiftData]);

  const handleSetShiftFormData = (e) => {
    const { name, value } = e.target;
    setShiftFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setShiftFormData((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
    }));
  };

  const handleUpdateWeekendDefinition = (object) => {
    let prevShiftData = shiftFormData;
    prevShiftData.weekendDefinition = object;
    setShiftFormData({ ...shiftFormData });
  };

  const { handleAuth } = usePut({
    url: "shift_create",
    refreshUrl: ["shift_listing", "dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: () => {
      toast.success("Shift Created Successfully");
      onClose();
      clearData();
      if (sessionStorage.getItem("onboarding_flow") === "true") {
        sessionStorage.removeItem("onboarding_flow");
        // navigate("/onboarding");
      }
    },
    onError: (err) => {
      const { status, data } = err;
      if (status >= 400 || status <= 499) {
        toast.error(data.message);
      } else {
        toast.error("Internal Server Error");
      }
    },
  });

  const handleSubmitShiftData = (e) => {
    e.preventDefault();
    setValidationErrors({});
    let errors = {};

    if (!shiftFormData.workingTypeMode) {
      errors.workingTypeMode = "Working Type is required";
    }

    if (shiftFormData.workingTypeMode === "strict") {
      // Validations
      if (
        shiftFormData.punch_in_reminder_needed === 1 &&
        shiftFormData.punch_in_reminder_time &&
        shiftFormData.shiftOutTime &&
        shiftFormData.punch_in_reminder_time >= shiftFormData.shiftOutTime
      ) {
        errors.punch_in_reminder_time =
          "Punch in reminder time must be less than shift out time";
      }

      if (
        shiftFormData.reminder_needed === 1 &&
        shiftFormData.reminder_time &&
        shiftFormData.shiftInTime &&
        shiftFormData.reminder_time <= shiftFormData.shiftInTime
      ) {
        errors.reminder_time =
          "Punch out reminder time must be greater than shift in time";
      }
    }
    // Clone the data to avoid mutating state directly
    const payload = JSON.parse(JSON.stringify(shiftFormData));

    console.log("Final Shift Payload:", payload);
    handleAuth.mutate(payload);
  };

  const handleCloseDialog = () => {
    clearData();
    onClose();
  };

  const clearData = () => {
    setShiftFormData(formData);
    setValidationErrors({});
  };

  function hasSelectedTrue(obj) {
    for (const day in obj) {
      if (obj[day].some((item) => item.weekendDay === "first_half")) {
        return true;
      }
    }
    return false;
  }

  function hasSelectedSecondHalfTrue(obj) {
    for (const day in obj) {
      if (obj[day].some((item) => item.weekendDay === "second_half")) {
        return true;
      }
    }
    return false;
  }

  const handleChangeIsHalfDayGrace = (e) => {
    let checked = e.target.checked;
    setShiftFormData((prev) => {
      return {
        ...prev,
        half_day_grace: {
          ...prev.half_day_grace,
          isEnabled: checked ? 1 : 0,
        },
      };
    });
  };

  const handleChangeHalfDayGraceTime = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setShiftFormData((prev) => {
      return {
        ...prev,
        half_day_grace: {
          ...prev.half_day_grace,
          [name]: value,
        },
      };
    });
  };

  return (
    <>
      <Drawer anchor={"right"} open={open} onClose={handleCloseDialog}>
        <div
          className="h-full bg-white px-8"
          style={{ width: "calc(100vw - 250px)" }}
        >
          <form className=" space-y-8" onSubmit={handleSubmitShiftData}>
            <div className="flex items-center justify-between  py-5 border-b border-gray-200 sticky z-40 top-0 bg-white">
              <div className="flex items-center space-x-3">
                <ArrowLeftIcon
                  className=" text-gray-700 w-8 h-8 cursor-pointer"
                  onClick={handleCloseDialog}
                />
                <p className="text-gray-700 text-3xl font-semibold">
                  Shift Details
                </p>
              </div>
              <Button className={"px-4 py-2"} type="submit" disabled={handleAuth.isLoading}>
                Save Shift
              </Button>
            </div>
            <div className="">
              {/* Row 1: Basic Info & Shift Timing */}
              <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100">
                <div>
                  <div className="">
                    <label className="label">Shift Name: </label>
                    <input
                      type="text"
                      name="shiftName"
                      disabled={mode === "edit"}
                      value={shiftFormData.shiftName}
                      onChange={handleSetShiftFormData}
                      required={true}
                      className="input"
                      placeholder="Enter Shift name "
                    />
                  </div>
                </div>
                <div className="px-4">
                  <p className="label">Working Type:</p>
                  <div className=" flex gap-x-4">
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="workingTypeMode"
                      value={shiftFormData.workingTypeMode}
                      onChange={handleSetShiftFormData}
                    >
                      <FormControlLabel
                        value="strict"
                        control={<Radio />}
                        label="Fixed"
                      />
                      <FormControlLabel
                        value="lenient"
                        control={<Radio />}
                        label="Flexible"
                      />
                    </RadioGroup>
                  </div>
                  {validationErrors.workingTypeMode && (
                    <p className="text-red-500 text-xs mt-1">
                      {validationErrors.workingTypeMode}
                    </p>
                  )}
                </div>

                {shiftFormData.workingTypeMode === "strict" && (
                  <>
                    <div>
                      <label className="label">Shift In-Time: </label>
                      <input
                        type="time"
                        name="shiftInTime"
                        value={shiftFormData.shiftInTime}
                        onChange={handleSetShiftFormData}
                        required={true}
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label">Shift Out-Time: </label>
                      <input
                        type="time"
                        name="shiftOutTime"
                        required={true}
                        value={shiftFormData.shiftOutTime}
                        onChange={handleSetShiftFormData}
                        className="input"
                      />
                    </div>
                  </>
                )}
              </div>

              {/* Flexible Section (Untouched logic-wise, just ensuring grid closure) */}
              {shiftFormData.workingTypeMode === "lenient" && (
                <div className="col-span-4 grid grid-cols-4 gap-4 py-5 border-b border-gray-100">
                  <div>
                    <label className="label">Working Hours: </label>
                    <input
                      type="number"
                      name="working_hours"
                      required={true}
                      value={shiftFormData.working_hours}
                      onChange={handleSetShiftFormData}
                      className="input"
                    />
                    <small className=" text-red-500 font-semibold">
                      Enter in hours
                    </small>
                  </div>
                  <div>
                    <label className="label">
                      Minimum Monthly Working Hours:{" "}
                    </label>
                    <input
                      type="number"
                      name="minimum_working_hours"
                      required={true}
                      value={shiftFormData.minimum_working_hours}
                      onChange={handleSetShiftFormData}
                      className="input"
                    />
                    <small className=" text-red-500 font-semibold">
                      Enter in hours
                    </small>
                  </div>
                  <div>
                    <label className="label">
                      Maximum Monthly Working Hours:{" "}
                    </label>
                    <input
                      type="number"
                      name="maximum_working_hours"
                      required={true}
                      value={shiftFormData.maximum_working_hours}
                      onChange={handleSetShiftFormData}
                      className="input"
                    />
                    <small className=" text-red-500 font-semibold">
                      Enter in hours
                    </small>
                  </div>
                </div>
              )}

              {shiftFormData.workingTypeMode === "strict" && (
                <div className="space-y-2">
                  {/* Row 2: Half Shift Times */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100">
                    <div>
                      <label className="label">First Half In-Time: </label>
                      <input
                        type="time"
                        name="first_half_in_time"
                        value={shiftFormData.first_half_in_time}
                        onChange={handleSetShiftFormData}
                        required={hasSelectedTrue(shiftFormData.weekendDefinition)}
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label">First Half Out-Time: </label>
                      <input
                        type="time"
                        name="first_half_out_time"
                        required={hasSelectedTrue(shiftFormData.weekendDefinition)}
                        value={shiftFormData.first_half_out_time}
                        onChange={handleSetShiftFormData}
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label">Second Half In-Time: </label>
                      <input
                        type="time"
                        name="second_half_in_time"
                        value={shiftFormData.second_half_in_time}
                        onChange={handleSetShiftFormData}
                        required={hasSelectedSecondHalfTrue(shiftFormData.weekendDefinition)}
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label">Second Half Out-Time: </label>
                      <input
                        type="time"
                        name="second_half_out_time"
                        required={hasSelectedSecondHalfTrue(shiftFormData.weekendDefinition)}
                        value={shiftFormData.second_half_out_time}
                        onChange={handleSetShiftFormData}
                        className="input"
                      />
                    </div>
                  </div>

                  {/* Row 3: Grace Settings */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100">
                    <div>
                      <label className="label flex items-center">
                        Shift Grace In
                        <small className="text-blue-600 text-[10px] ml-1">(Min)</small>
                      </label>
                      <input
                        type="number"
                        placeholder="15"
                        value={shiftFormData.shiftGraceInTime}
                        onChange={handleSetShiftFormData}
                        name="shiftGraceInTime"
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label flex items-center">
                        Shift Grace Out
                        <small className="text-blue-600 text-[10px] ml-1">(Min)</small>
                      </label>
                      <input
                        type="number"
                        placeholder="15"
                        value={shiftFormData.shiftGraceOutTime}
                        onChange={handleSetShiftFormData}
                        name="shiftGraceOutTime"
                        className="input"
                      />
                    </div>
                  </div>

                  {/* Late Redemption row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="late_redemption_enabled"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="late_redemption_enabled"
                          name="late_redemption_enabled"
                          checked={shiftFormData.late_redemption_enabled === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Late Redemption?
                      </label>
                      <ToolTip content="Employees can redeem late arrivals by working extra time.">
                        <InformationCircleIcon className="w-5 h-5 text-blue-500 cursor-help" />
                      </ToolTip>
                    </div>
                    {shiftFormData.late_redemption_enabled === 1 && (
                      <div className="col-span-1">
                        <label className="label flex items-center">
                          Redemption Multiple
                          <ToolTip content="Multiplier for late duration. (e.g. 2.0 means 15m late = 30m extra work)">
                            <InformationCircleIcon className="w-4 h-4 text-blue-500 ml-1 cursor-help" />
                          </ToolTip>
                        </label>
                        <input
                          type="number"
                          step="0.1"
                          name="late_redemption_period"
                          value={shiftFormData.late_redemption_period}
                          onChange={handleSetShiftFormData}
                          className="input"
                          placeholder="e.g. 2.0"
                        />
                      </div>
                    )}
                  </div>

                  {/* Late Penalty row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="late_penalty"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="late_penalty"
                          name="late_penalty"
                          checked={shiftFormData.late_penalty === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Late Penalty?
                      </label>
                      <ToolTip 
                        content={
                          <div className="p-1 min-w-[200px]">
                            <p className="text-base font-bold mb-2 border-b border-gray-600 pb-1">Calculation Example</p>
                            <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                              <span className="text-gray-400">Threshold:</span> <span className="font-bold">3 Days</span>
                              <span className="text-gray-400">Penalty:</span> <span className="font-bold">0.5 Days</span>
                            </div>
                            <div className="grid grid-cols-2 gap-2 text-sm border-t border-gray-600 pt-2">
                              <span className="font-bold text-xs uppercase text-blue-400">Late Days</span>
                              <span className="font-bold text-xs uppercase text-blue-400">Penalty Days</span>
                              <span>3 Days</span> <span>0.5</span>
                              <span>4 Days</span> <span>0.5</span>
                              <span>6 Days</span> <span>1.0</span>
                            </div>
                          </div>
                        }
                      >
                        <InformationCircleIcon className="w-5 h-5 text-blue-500 cursor-help" />
                      </ToolTip>
                    </div>
                    {shiftFormData.late_penalty === 1 && (
                      <>
                        <div className="col-span-1">
                          <label className="label flex items-center">
                            Threshold (Days)
                            <ToolTip content="How many late days = 1 penalty block. (e.g. 3 days)">
                              <InformationCircleIcon className="w-4 h-4 text-blue-500 ml-1 cursor-help" />
                            </ToolTip>
                          </label>
                          <input
                            type="number"
                            name="late_threshold"
                            value={shiftFormData.late_threshold}
                            onChange={handleSetShiftFormData}
                            className="input"
                            placeholder="E.g. 3"
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="label flex items-center">
                            Penalty days
                            <ToolTip content="Penalty days added per block of late days. (e.g. 0.5 days)">
                              <InformationCircleIcon className="w-4 h-4 text-blue-500 ml-1 cursor-help" />
                            </ToolTip>
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            name="late_penalty_days"
                            value={shiftFormData.late_penalty_days}
                            onChange={handleSetShiftFormData}
                            className="input"
                            placeholder="E.g. 0.5"
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {/* Late Grace Available row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="late_grace_available"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="late_grace_available"
                          name="late_grace_available"
                          checked={shiftFormData.late_grace_available === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Late Grace?
                      </label>
                      <ToolTip content="Monthly pool of grace minutes before penalties apply.">
                        <InformationCircleIcon className="w-5 h-5 text-blue-500 cursor-help" />
                      </ToolTip>
                    </div>
                    {shiftFormData.late_grace_available === 1 && (
                      <div className="col-span-1">
                        <label className="label flex items-center">
                          Grace (Min)
                          <ToolTip content="Monthly allocation of grace minutes.">
                            <InformationCircleIcon className="w-4 h-4 text-blue-500 ml-1 cursor-help" />
                          </ToolTip>
                        </label>
                        <div className="flex items-center space-x-2">
                          <input
                            type="number"
                            name="late_grace_time"
                            value={shiftFormData.late_grace_time}
                            onChange={handleSetShiftFormData}
                            className="input"
                          />
                          <span className="text-gray-500 font-medium text-sm whitespace-nowrap">/ Mo</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Minimum Hours row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="minimum_hours_applicable"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="minimum_hours_applicable"
                          name="minimum_hours_applicable"
                          checked={shiftFormData.minimum_hours_applicable === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Min Working Hrs Req?
                      </label>
                      <ToolTip content="Minimum hours required daily to not be considered absent.">
                        <InformationCircleIcon className="w-5 h-5 text-blue-500 cursor-help" />
                      </ToolTip>
                    </div>
                    {shiftFormData.minimum_hours_applicable === 1 && (
                      <div className="col-span-1">
                        <label className="label flex items-center">
                          Min Daily Working Hours
                          <ToolTip content="Minimum daily work hours required to avoid an 'Absent' status.">
                            <InformationCircleIcon className="w-4 h-4 text-blue-500 ml-1 cursor-help" />
                          </ToolTip>
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          name="minimum_working_hours"
                          value={shiftFormData.minimum_working_hours}
                          onChange={handleSetShiftFormData}
                          className="input"
                        />
                      </div>
                    )}
                  </div>

                  {/* Simple Post Shift Out row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-center">
                    <div className="flex items-center space-x-2">
                      <label
                        htmlFor="calculate_post_shift_out"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="calculate_post_shift_out"
                          name="calculate_post_shift_out"
                          checked={shiftFormData.calculate_post_shift_out === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Post Shift Out?
                      </label>
                      <ToolTip content="Include extra time worked after shift end.">
                        <InformationCircleIcon className="w-5 h-5 text-blue-500 cursor-help" />
                      </ToolTip>
                    </div>
                  </div>

                  {/* Half Day & Margin Configuration */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div>
                      <label className="label">Half In Time: </label>
                      <input
                        type="time"
                        name="halfDayInTime"
                        value={shiftFormData.halfDayInTime}
                        onChange={handleSetShiftFormData}
                        className="input"
                      />
                    </div>
                    <div>
                      <label className="label">Half Out Time: </label>
                      <input
                        type="time"
                        name="halfDayOutTime"
                        value={shiftFormData.halfDayOutTime}
                        onChange={handleSetShiftFormData}
                        className="input"
                      />
                    </div>
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="half_day_late_enable"
                        className={`label text-base flex items-center mb-0 ${(!shiftFormData.halfDayInTime || shiftFormData.halfDayInTime === "null") ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        <input
                          type="checkbox"
                          id="half_day_late_enable"
                          name="half_day_late_enable"
                          disabled={!shiftFormData.halfDayInTime || shiftFormData.halfDayInTime === "null"}
                          checked={shiftFormData.half_day_late_enable === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4"
                        />
                        Calculate Late?
                      </label>
                      <ToolTip content={(!shiftFormData.halfDayInTime || shiftFormData.halfDayInTime === "null") ? "Requires Half In Time to be set." : "Calculate late even on half days."}>
                        <InformationCircleIcon className={`w-5 h-5 cursor-help ${(!shiftFormData.halfDayInTime || shiftFormData.halfDayInTime === "null") ? "text-gray-400" : "text-blue-500"}`} />
                      </ToolTip>
                    </div>
                  </div>

                  {/* Half Day Grace Row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center space-x-2 pb-2">
                      <label
                        htmlFor="halfDayGrace"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="halfDayGrace"
                          name="halfDayGrace"
                          checked={shiftFormData.half_day_grace.isEnabled === 1}
                          onChange={handleChangeIsHalfDayGrace}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Half Day Grace?
                      </label>
                    </div>
                    {shiftFormData.half_day_grace.isEnabled === 1 && (
                      <div className="col-span-1">
                        <label className="label flex items-center">
                          Grace Out <small className="text-blue-600 text-[10px] ml-1">(Min)</small>
                        </label>
                        <input
                          type="number"
                          placeholder="15"
                          value={shiftFormData?.half_day_grace?.half_day_grace_out_time}
                          onChange={handleChangeHalfDayGraceTime}
                          required={true}
                          name="half_day_grace_out_time"
                          className="input"
                        />
                      </div>
                    )}
                  </div>

                  {/* Punch In Reminder row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center pb-2">
                      <label
                        htmlFor="punch_in_reminder_needed"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="punch_in_reminder_needed"
                          name="punch_in_reminder_needed"
                          checked={shiftFormData.punch_in_reminder_needed === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Punch In Reminder?
                      </label>
                    </div>
                    {shiftFormData.punch_in_reminder_needed === 1 && (
                      <div className="col-span-1">
                        <label className="label">Reminder Time: </label>
                        <input
                          type="time"
                          name="punch_in_reminder_time"
                          value={shiftFormData.punch_in_reminder_time}
                          onChange={handleSetShiftFormData}
                          required={true}
                          className={`input ${validationErrors.punch_in_reminder_time ? "border-red-500" : ""}`}
                        />
                      </div>
                    )}
                  </div>

                  {/* Punch Out Reminder row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center pb-2">
                      <label
                        htmlFor="reminderNeeded"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="reminderNeeded"
                          name="reminder_needed"
                          checked={shiftFormData.reminder_needed === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Punch Out Reminder?
                      </label>
                    </div>
                    {shiftFormData.reminder_needed === 1 && (
                      <div className="col-span-1">
                        <label className="label">Reminder Time: </label>
                        <input
                          type="time"
                          name="reminder_time"
                          value={shiftFormData.reminder_time}
                          onChange={handleSetShiftFormData}
                          required={true}
                          className={`input ${validationErrors.reminder_time ? "border-red-500" : ""}`}
                        />
                      </div>
                    )}
                  </div>

                  {/* Cut-off row */}
                  <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                    <div className="flex items-center pb-2">
                      <label
                        htmlFor="cutoffNeeded"
                        className="label text-base flex items-center cursor-pointer mb-0"
                      >
                        <input
                          type="checkbox"
                          id="cutoffNeeded"
                          name="cut_off_needed"
                          checked={shiftFormData.cut_off_needed === 1}
                          onChange={handleCheckboxChange}
                          className="mr-2 w-4 h-4 cursor-pointer"
                        />
                        Cut-off needed?
                      </label>
                    </div>
                    {shiftFormData.cut_off_needed === 1 && (
                      <>
                        <div className="col-span-1">
                          <label className="label">Cut-off Time: </label>
                          <input
                            type="time"
                            name="cut_off_time"
                            value={shiftFormData.cut_off_time}
                            onChange={handleSetShiftFormData}
                            required={true}
                            className="input"
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="label">Cut-off Method: </label>
                          <select
                            name="cut_off_method"
                            value={shiftFormData.cut_off_method || ""}
                            onChange={handleSetShiftFormData}
                            required={true}
                            className="input"
                          >
                            <option value="" disabled>Choose</option>
                            <option value="ABSENT">Absent</option>
                            <option value="SHIFT_OUT">Shift Out Time</option>
                          </select>
                        </div>
                      </>
                    )}
                  </div>

                </div>
              )}

              {/* Remote Work row (Global) */}
              <div className="grid grid-cols-4 gap-5 py-5 border-b border-gray-100 items-end">
                <div className="flex items-center pb-2">
                  <label
                    htmlFor="rwPunchTimeDiff"
                    className="label text-base flex items-center cursor-pointer mb-0"
                  >
                    <input
                      type="checkbox"
                      id="rwPunchTimeDiff"
                      name="rw_punch_time_diff_applicable"
                      checked={shiftFormData.rw_punch_time_diff_applicable === 1}
                      onChange={handleCheckboxChange}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    Remote Interval?
                  </label>
                </div>
                {shiftFormData.rw_punch_time_diff_applicable === 1 && (
                  <div className="col-span-1">
                    <label className="label">Interval (Min): </label>
                    <input
                      type="number"
                      name="rw_punch_time_diff"
                      value={shiftFormData.rw_punch_time_diff}
                      onChange={handleSetShiftFormData}
                      required={true}
                      className="input"
                    />
                  </div>
                )}
              </div>

            {shiftFormData.workingTypeMode !== "lenient" && (
              <div className="py-5">
                <p className="text-gray-700 text-3xl font-semibold mb-4">
                  Weekend Definition
                </p>
                <LikertView
                  mode={mode}
                  onChange={(values) => handleUpdateWeekendDefinition(values)}
                  values={shiftFormData.weekendDefinition}
                />
              </div>
            )}
            </div>
          </form>
        </div>
      </Drawer>
    </>
  );
};

export default AdvanceShiftEditing;
